import styled from 'styled-components'

import { theme } from '@/styles/theme'

export const DownloadButton = styled.div`
  > a {
    > button {
      display: inline-flex;
      padding: 12px 20px 15px 20px;
      justify-content: center;
      align-items: center;
      gap: 12px;
      height: 46px;
      background: #ffffff;
      color: ${theme.colors.trialBlue};
      border: 1px solid ${theme.colors.trialBlue};
      border-radius: 25px;
      box-sizing: border-box;
      @media screen and (max-width: 1047px) {
        padding: 2px 18px 4px;
        height: 32px;
        font-size: 13px;
      }

      > svg {
        width: 20px;
        height: 18px;
        flex-shrink: 0;
        fill: ${theme.colors.trialBlue};
      }

      > span:first-of-type {
        text-align: center;
        font-size: 17px;
        font-weight: 700;
        line-height: 1;
        letter-spacing: 0.68px;
      }

      > span:nth-of-type(2) {
        color: ${theme.colors.textSecond};
        font-size: 13px;
        font-weight: 500;
        line-height: 1;
        letter-spacing: 0.52px;
      }
    }
    &:hover > button {
      background-color: ${theme.colors.hoverLightBlue};
      border-color: ${theme.colors.hoverLightBlue};
      color: #ffffff;

      > svg {
        fill: #ffffff;
      }

      > span {
        color: #ffffff;
      }
    }
  }
`
